import React, { useState } from 'react';
import PropTypes from 'prop-types';

import IString from '../../common/components/i-string';
import WaitButton from '../../common/components/wait-button';

import { translate } from '../../common/i18n/localize';
import { serverToQueryString } from '../../common/util/server-util';

function EmailForm(props) {
  const { email: originalEmail, onSubmit } = props;

  const [email, setEmail] = useState(originalEmail);
  const [pending, setPending] = useState(false);
  const query = serverToQueryString();
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setPending(true);
    onSubmit(e.target.elements.email.value);
  };

  return (
    <form className="noPaddingBottom" onSubmit={handleSubmit}>
      <fieldset className='chunk'>
        <input 
          autoFocus 
          name='email' 
          onChange={e => setEmail(e.target.value)} 
          placeholder={translate('email.placeholder')}
          required 
          type='email'
          value={email || ''} />
      </fieldset>

      <fieldset className='actions noMarginAbove'>
        <WaitButton type='submit' wait={pending}>
          <IString stringKey='email.submit' />
        </WaitButton>
      </fieldset>
      <div className='marginAbove right'>
        <strong><a href={`/forgot_password${query}`}><IString stringKey='password.forgot'></IString></a></strong>
      </div>
    </form>
  );
}

EmailForm.propTypes = {
  email: PropTypes.string,
  onSubmit: PropTypes.func.isRequired
};

export default EmailForm;
